import axiosInstance from '../plugin/axios';

interface FetchReceiveNotificationParams {
  offset?: number;
  limit?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
}

interface FetchNotificationResponse {
  orderId: number;
  obtainId: number;
  name: string;
  content: string;
  createdAt: string;
  vehicle?: string;
}

interface ServerResponse {
  statusCode: number;
  message: string;
}

// 기사 회원 받은 알림
export const fetchReceiveNotificationDriver = async ({
  offset = 0,
  limit = 50,
  sortBy = 'createdAt',
  order = 'desc',
}: FetchReceiveNotificationParams): Promise<FetchNotificationResponse[]> => {
  try {
    const response = await axiosInstance.get<FetchNotificationResponse[]>(
      '/api/notification/driver/receive',
      {
        params: {
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching notification data:', error);
    throw new Error('Failed to fetch notifications');
  }
};

// 기사 회원 보낸 알림
export const fetchSendNotificationDriver = async ({
  offset = 0,
  limit = 50,
  sortBy = 'createdAt',
  order = 'desc',
}: FetchReceiveNotificationParams): Promise<FetchNotificationResponse[]> => {
  try {
    const response = await axiosInstance.get<FetchNotificationResponse[]>(
      `/api/notification/driver/send`,
      {
        params: {
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Error fetching notification data:', error);
    throw new Error('Failed to fetch notifications');
  }
};

// 회사 회원 받은 알림
export const fetchReceiveNotificationCompany = async ({
  offset = 0,
  limit = 50,
  sortBy = 'createdAt',
  order = 'desc',
}: FetchReceiveNotificationParams): Promise<FetchNotificationResponse[]> => {
  try {
    const response = await axiosInstance.get<FetchNotificationResponse[]>(
      '/api/notification/company/receive',
      {
        params: {
          offset,
          limit,
          sortBy,
          order,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching notification data:', error);
    throw new Error('Failed to fetch notifications');
  }
};

//  회사 회원 보낸 알림
export const fetchSendNotificationCompany = async ({
  offset = 0,
  limit = 50,
  sortBy = 'createdAt',
  order = 'desc',
}: FetchReceiveNotificationParams): Promise<FetchNotificationResponse[]> => {
  try {
    const response = await axiosInstance.get<FetchNotificationResponse[]>(
      '/api/notification/company/send',
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

// 받은 알림 상세 보기
export const fetchNotificationDetail = async () => {
  try {
  } catch (error) {
    throw new Error();
  }
};

// 도착 알림 생성
export const fetchArrivalNotification = async (
  orderId: number,
  obtainId: number,
): Promise<ServerResponse> => {
  try {
    const response = await axiosInstance.post<ServerResponse>(
      `/api/notification/driver/${orderId}/${obtainId}`,
    );

    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchNotificationComfirm = async () => {
  try {
    const response = await axiosInstance.get(`/api/notification/confirm`);

    return response.data;
  } catch (error) {
    throw new Error();
  }
};
